import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4 8V18",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.77881 26.9999C7.77815 25.4648 9.14492 24.2035 10.7551 23.3304C12.3654 22.4573 14.1681 22 15.9998 22C17.8315 22 19.6342 22.4573 21.2444 23.3304C22.8547 24.2035 24.2214 25.4648 25.2208 26.9999",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M28 8L16 12L4 8L16 4L28 8Z",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.1671 10.2776C22.083 11.2798 22.6878 12.5267 22.9076 13.8665C23.1275 15.2062 22.953 16.581 22.4053 17.8234C21.8577 19.0657 20.9606 20.122 19.8234 20.8636C18.6861 21.6052 17.3577 22 16 22C14.6423 22 13.3139 21.6052 12.1766 20.8636C11.0394 20.122 10.1423 19.0657 9.59467 17.8234C9.04705 16.581 8.87254 15.2062 9.09239 13.8665C9.31224 12.5267 9.91696 11.2798 10.8329 10.2776",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }